export enum ItemFieldTypes {
	TEXT_INPUT = "text_input",
	INT_INPUT = "int_input",
	FLOAT_INPUT = "float_input",
	TEXT_AREA = "text_area",
	DATE = "date",
	SELECT = "select",
	MULTISELECT = "multiselect",
	RADIO = "radio",
	CHECKBOX = "checkbox",
	PERCENTAGE_INPUT = "percentage_input",
	CURRENCY_INPUT = "currency_input",
}
